import React from "react"
import PropTypes from "prop-types"
import {graphql, useStaticQuery} from "gatsby"

import "./style.scss"
import Header from "../Header"
import Footer from "../Footer"
import Consent from "../Consent"
import SEO from "../SEO"

const Layout = ({children, ...rest}) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <PureLayout {...rest} data={data}>
      {children}
    </PureLayout>
  )
}

export const PureLayout = ({
  children,
  data,
  title,
  description = "",
  className = "",
}) => (
  <div className={`layout ${className}`}>
    <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
    <main className="container" style={{paddingTop: 150 + "px"}}>
      <SEO title={title} description={description} />
      {children}
    </main>
    <Footer siteTitle={data.site.siteMetadata?.title || "Title"} />
    <Consent />
  </div>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
